export default {
      id: "ic_checkmark-usage",
      viewBox: "0 0 7 6",
      url: "/" + "images/icons.3.109.2.svg#ic_checkmark-usage",
      toString: function () {
        return this.url;
      }
    }